import axios from 'axios'
import { withHeadersInstance } from './api-instance'
// import qs from 'qs'
import { getSavedState } from '@src/utils/localStorage'

const baseUrl = process.env.VUE_APP_URL_API

axios.defaults.headers.common = {
    'Content-Type': 'application/json',
}

export const GetLocationBuyer = async function(parameters) {
    try {
        const { publicId } = parameters
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const url = `${baseUrl}/location/${locationPublicId}/location-store/${publicId}`
        if (publicId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: publicId')
            )
        return await withHeadersInstance({
            method: 'get',
            url: url,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}

export const PutLocationBuyer = async function(parameters) {
    try {
        const { publicId } = parameters
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const url = `${baseUrl}/location/${locationPublicId}/location-store/${publicId}`
        return await withHeadersInstance({
            method: 'put',
            url: url,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}

export const GetList = async function(parameters) {
    const { locationId } = parameters
    try {
        const url = `${baseUrl}/location/${locationId}/location-stores`
        return await withHeadersInstance({
            method: 'get',
            url: url,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}

export const PostLocationBuyer = async function(parameters) {
    try {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const url = `${baseUrl}/location/${locationPublicId}/location-store`
        return await withHeadersInstance({
            method: 'post',
            url: url,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}

export const ChangeLocationBuyerStatus = async function(parameters) {
    try {
        const { publicId } = parameters
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const url = `${baseUrl}/location/${locationPublicId}/location-store-status/${publicId}`
        if (publicId === undefined) {
            return Promise.reject(
                new Error('Missing required  parameter: publicId')
            )
        }
        return await withHeadersInstance({
            method: 'put',
            url: url,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}
